import React, { createContext, useEffect, useState } from 'react';
import { PlayerEvents, PlayerActions, PlayerControlData, } from '../../../index';
import usePlayerEventData from '../../../hooks/usePlayerEventData/usePlayerEventData';
export const PresentationPlayerContext = createContext(null);
PresentationPlayerContext.displayName = 'PresentationPlayerContext';
const PresentationPlayerProvider = (props) => {
    const playerEventData = usePlayerEventData();
    const [currentPlayerState, setCurrentPlayerState] = useState();
    /**
     * playerEventData useEffect handler which watches for player status updates and
     * stores them as jumpToAnim PlayerControlData messages in currentPlayerState.
     * This can then be used in the virtual environment to support init of attendees
     * joining mid presentation.
     */
    const handlePlayerEvent = () => {
        if (playerEventData?.event === PlayerEvents.statusEvent) {
            const newParam = {
                step: playerEventData.param.step,
                slide: playerEventData.param.slide,
            };
            const updatedPlayerState = new PlayerControlData(PlayerActions.jumpToAnim, newParam);
            setCurrentPlayerState(updatedPlayerState);
        }
    };
    useEffect(handlePlayerEvent, [playerEventData]);
    const contextValue = {
        playerEventData,
        currentPlayerState,
        setCurrentPlayerState,
    };
    return (<PresentationPlayerContext.Provider value={contextValue}>
      {props.children}
    </PresentationPlayerContext.Provider>);
};
PresentationPlayerProvider.displayName = 'PresentationPlayerProvider';
export default PresentationPlayerProvider;
//# sourceMappingURL=PresentationPlayerContext.js.map